import axios from "axios"

const CONFIG = {
  spaceId: `j4osy1ytcga2`,
  env: `master`,
  token: process.env.GATSBY_CTF_TOKEN,
}

export const getEntries = async (queryParams, config = CONFIG) => {
  const url = Object.keys(queryParams).reduce((query, key) => {
    return query + `&` + key + `=` + queryParams[key]
  }, `https://cdn.contentful.com/spaces/` + config.spaceId + `/environments/` + config.env + `/entries?access_token=` + config.token)
  return await axios(url)
}

export const resolveApiResponse = ({ includes, items }) => {
  return items.map(({ fields }) => {
    const linkKeys = Object.keys(fields).filter(
      field => typeof fields[field] === `object`
    )
    const links = linkKeys.reduce((linkedObjs, key) => {
      const linkData = includes[fields[key].sys.linkType].find(
        ({ sys }) => sys.id === fields[key].sys.id
      )
      return { ...linkedObjs, [key]: linkData.fields }
    }, {})
    return { ...fields, ...links }
  })
}
